module.exports = __webpack_public_path__ + "static/4-1364dd958d123305cd6ba157a9f37a70.jpg";